import CHIPSAJ from "./_chips-aj.js";
import CHIPS_KEYBOARD_NAV from "./_chips-keyboardnav.js";
function bg() {
	$("body").toggleClass("bg-alt");
}

const ajTF = true;
const app = {
	init: function () {
		return this;
	},
	ajObj: CHIPSAJ.init(),
	kbNav: CHIPS_KEYBOARD_NAV.init(),
	initPage: function (pID) {},
	initCarousels: function () {},
};

$(".reveal-tag").on("click", function () {
	$(".type-reveal").addClass("reveal-on");
});







// lightGallery(document.getElementById("ul-li"), {
// 	licenseKey: "23D9B845-65F4-485B-9F5E-44232F37BEB1",
// 	selector: "a",
// 	thumbnail: true,
// 	zoom: true,
// 	animateThumb: false,
// 	zoomFromOrigin: false,
// 	allowMediaOverlap: true,
// 	toggleThumb: true,
// 	mode: "lg-fade",
// });


// $('.material-cycle-wrap').flickity({
// 	wrapAround: true,
// 	prevNextButtons: true,
// 	cellSelector: '.material-cycle-single'
// });
